<template>
  <div class="OverviewsItem flex justify-between items-center space-x-2 w-full hover:bg-gray-100 border-b border-gray-400 px-2">
    <div 
      class="rounded-full h-3 w-3 flex-shrink-0"
      :class="{'bg-red-500': share.canceled, 'bg-green-500': share.view_cnt > 0 && !share.canceled, 'bg-bc-blue': !share.view_cnt && !share.canceled}"
    />
    <div class="OverviewsSharedItemLabel w-full flex justify-between items-center text-sm">
      <span 
        v-if="share.user?.email"
        class="truncate"
      >
        {{ share.user?.email }}
      </span>
      <a 
        v-else-if="link"
        :href="link"
        class="truncate"
        target="_blank"
      >
        {{ link }}
      </a>
      <span 
        v-if="share.view_cnt"
        class="ml-1"
      >
        ({{ share.view_cnt }}x)
      </span>
    </div>
    <span 
      class="text-gray-400 text-sm"
      v-if="share.date_to"
    >
      {{ $t('Expires') }}: <span class="whitespace-nowrap">{{ formatDate(share.date_to, 'd. m. Y') }}</span>
    </span>
    <span 
      class="text-gray-400 text-sm"
      v-else
    >
      {{ $t('Sharing failed') }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    share: Object,
  },
  data() {
    return {
    }
  },
  computed: {
    link() {
      return window.location.origin + this.share?.link
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.OverviewsSharedItemLabel {
  max-width: calc(100% - 180px);
}
</style>
